import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { LearningResourcesUploadsRoutingModule } from './learning-resources-uploads-routing.module';
import { LearningResourcesUploadsListComponent } from './learning-resources-uploads-list/learning-resources-uploads-list.component';
import { LearningResourcesUploadsCreateComponent } from './learning-resources-uploads-create/learning-resources-uploads-create.component';

@NgModule({
  declarations: [LearningResourcesUploadsListComponent, LearningResourcesUploadsCreateComponent],
  imports: [
    CommonModule,
    LearningResourcesUploadsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class LearningResourcesUploadsModule { }
